module.exports = __webpack_public_path__ + "img/kualitas-terbaik.55caaa22.svg";